import { Pipe, PipeTransform } from "@angular/core";
import { ceilTo } from "../functions";

@Pipe({
  name: "ceilTo"
})
export class CeilToPipe implements PipeTransform {
  transform(x: number, roundTo: number): number {
    return ceilTo(x, roundTo);
  }
}
